class TabsManager extends HTMLElement {
  constructor() {
    super();

    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.init());
    } else {
      this.init();
    }
  }

  init() {
    this.buttons = this.querySelectorAll('.tab-button');
    this.contents = this.querySelectorAll('.tab-content');

    // Add initial active state if none exists
    if (!this.querySelector('.tab-button.is-selected')) {
      this.buttons[0]?.classList.add('is-selected');
      this.contents[0]?.classList.add('is-active');
    }

    this.buttons.forEach((button, index) => {
      button.addEventListener('click', (e) => {
        e.preventDefault(); // Prevent default button behavior
        this.switchTab(button);
      });
    });
  }

  switchTab(selectedButton) {
    // Remove selected class from all buttons
    this.buttons.forEach(btn => btn.classList.remove('is-selected'));
    // Add selected class to clicked button
    selectedButton.classList.add('is-selected');

    // Hide all content
    this.contents.forEach(content => {
      content.classList.remove('is-active');
    });

    // Show selected content
    const tabId = selectedButton.getAttribute('data-tab');
    const activeContent = this.querySelector(`[data-tab-content="${tabId}"]`);

    if (activeContent) {
      activeContent.classList.add('is-active');
    }
  }
}

if (!customElements.get('tabs-manager')) {
  customElements.define('tabs-manager', TabsManager);
}
